export const JOB_STATUSES = {
  RUNNING: 'Running',
  PAUSED: 'Paused',
  FINISHED: 'Finished',
  SKIPPED: 'Skipped',
  NOT_STARTED: 'NotStarted',
  START: 'Start',
};

export const JOB_STATUSES_TEXT = {
  [JOB_STATUSES.RUNNING]: 'Running',
  [JOB_STATUSES.PAUSED]: 'Paused',
  [JOB_STATUSES.FINISHED]: 'Finished',
  [JOB_STATUSES.SKIPPED]: 'Skipped',
  [JOB_STATUSES.NOT_STARTED]: 'Not Started',
  [JOB_STATUSES.START]: 'Start',
};
